import cookie from '@component/common/src/util/Cookie';
import 'whatwg-fetch';
import 'slick-carousel';
import $ from 'jquery';
import axios from 'axios';
import './src/scss/lenscrafters.scss';
import pkg from './package.json';
// visit us
import storesNotFound from './src/templates/partials/storesNotFound.hbs';

// glasses
import glassesGrid from './src/templates/partials/glassesGrid.hbs';
import glassesQV from './src/templates/partials/glassesQV.hbs';
import glassesMobileQV from './src/templates/partials/glassesMobileQV.hbs';

// wish list
import wishListDetails from './src/templates/partials/wishListDetails.hbs';

// import rawGlassesData from './tests/mocks/mockGlassesList.json';

import rawData from './lc_glasses_data';
import glassesData from './lc_glasses_201912.json';

/* eslint-disable-next-line no-unused-vars,no-global-assign,no-undef,camelcase */
__webpack_public_path__ = `${pkg.version}/`;

export default {
  start: () => {
    // Read the bootstrap data (have required env variable) rendered in the DOM from platform
    let bootStrapData = {};
    try {
      bootStrapData =
        $('script[data-bootstrap="page/marketing-campaigns"]').length !== 0
          ? JSON.parse(
              $('script[data-bootstrap="page/marketing-campaigns"]').html(),
            )
          : {};
    } catch (e) {
      console.error('Failed bootstraping env variables: ', e);
    }
    // console.log(bootStrapData.IMP_API_URL);

    $('.backtotop-btn').click(() => {
      $('html, body').animate(
        {
          scrollTop: $('#campaign').offset().top,
        },
        1000,
      );
    });

    /* eslint-disable-next-line no-unused-vars,no-global-assign,no-undef,camelcase */
    function isMobile() {
      if (window.innerWidth < 1024) {
        return true;
      }
      return false;
    }

    function getUrlParameter(sParam) {
      const sPageURL = decodeURIComponent(window.location.search.substring(1));
      const sURLVariables = sPageURL.split('&');
      let sParameterName;

      for (let i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : sParameterName[1];
        }
      }
      return undefined;
    }

    /* eslint-disable-next-line no-unused-vars,no-global-assign,no-undef,camelcase */
    function processGlassesData(allText) {
      const allTextLines = allText.split(/\r\n|\n/);
      // don't split within quotes
      const headers = allTextLines[0].split(',');
      // console.log('raw data header', headers);
      const lines = [];

      for (let i = 1; i < allTextLines.length; i++) {
        const data = allTextLines[i].split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);
        if (data.length === headers.length) {
          const product = {};
          for (let j = 0; j < headers.length; j++) {
            if (j === 1) {
              // skip pictures attribute
            } else if (j === 4) {
              // brand to uppercase
              product[headers[j]] = data[j].toLowerCase();
            } else if (j === 5) {
              // productId
              let parsedId = data[j].split(' ')[0];
              if (parsedId[0] === '0') {
                parsedId = parsedId.substring(1);
              }
              product.productId = parsedId;
            } else if (j === 7) {
              // colorName
              product[headers[j]] = data[j].toLowerCase();
            } else if (j === 9 || j === 10 || j === 11) {
              // size
              product.sizing = product.sizing || {};
              product.sizing[headers[j]] = Number(data[j].trim());
            } else if (j === 12) {
              // material
              product[headers[j]] = data[j].toLowerCase();
            } else if (j === 13) {
              // shape
              product[headers[j]] = data[j].toLowerCase();
            } else if (j === 15) {
              // gender
              const gender = data[j].trim().toLowerCase();

              const maleMap = new Set([
                'm',
                'man',
                'men',
                'male',
                'males',
                'boy',
                'boys',
              ]);
              const femaleMap = new Set([
                'f',
                'woman',
                'women',
                'female',
                'females',
                'girl',
                'girls',
              ]);
              const uniMap = new Set(['u', 'universal', 'unisex']);

              product.gender = product.gender || {};

              if (maleMap.has(gender) || uniMap.has(gender)) {
                product.gender.men = true;
              }
              if (femaleMap.has(gender) || uniMap.has(gender)) {
                product.gender.women = true;
              }
            } else if (j === 16) {
              // price
              product.price = Number(data[j].trim().substring(1)).toFixed(2);
            } else if (j >= 18 && j <= 21) {
              // face shape
              if (data[j].trim().length > 0) {
                product.faceShape = product.faceShape || {};
                product.faceShape[headers[j]] = true;
              }
            } else if (j === 23) {
              // fit
              product[headers[j]] = data[j].toLowerCase();
            } else {
              product[headers[j]] = data[j];
            }

            product.imgName = `${product.productId}__${product.colorId}_030A`;
            product.imgAlt = `${product.brand}-${product.productId}-${product.colorId}`;
          }
          lines.push(product);
        }
      }
      // console.log('RAW Glasses Data', lines);
      return lines;
    }

    function homeInit() {
      const $homeEl = document.querySelector('#campaign #home');
      const $forms = document.querySelectorAll('.locator-form');
      $forms.forEach(($form) => {
        $form.addEventListener('submit', (event) => {
          event.preventDefault();
          const formData = new FormData($form);
          const searchValue = formData.get('locator-form-input');
          window.location.href = `/p/lenscrafters/visit-us/?s=${searchValue}`;
        });
      });
    }
    /* eslint-disable-next-line no-unused-vars,no-global-assign,no-undef,camelcase */

    /* eslint-disable-next-line no-unused-vars,no-global-assign,no-undef,camelcase */
    async function glassesInit() {
      const filterMap = {
        gender: ['Men', 'Women', 'Kids', 'All'],
        brand: [],
        style: [],
        color: [
          'Black',
          'Clear / White',
          'Copper / Bronze',
          'Silver / Gunmetal',
          'Grey',
          'Tortoise',
          'Brown / Tan',
          'Blue',
          'Green',
          'Yellow / Orange',
          'Pink / Purple',
          'Multi',
          'Red / Burgundy',
        ],
        material: ['Metal', 'Plastic', 'Titanium'],
        fit: ['Standard', 'Wide', 'Petite'],
        face: ['oval', 'round', 'square', 'heart'],
        price: [
          'Under $150',
          '$150-$250',
          '$250-$350',
          '$350-$450',
          '$450 & Up',
        ],
      };
      let parsedGlassesData = [];
      let filteredData = [];
      const glassesMap = {};

      function fetchGlasses() {
        const brandsMap = {};
        const stylesMap = {};
        const materialsMap = {};
        const fitsMap = {};
        const colorsMap = {};

        parsedGlassesData = processGlassesData(rawData);
        parsedGlassesData.forEach((product) => {
          glassesMap[product.productId] = glassesMap[product.productId] || {};
          glassesMap[product.productId][product.colorId] = product;

          if (brandsMap[product.brand] === undefined) {
            brandsMap[product.brand] = true;
          }
          if (stylesMap[product.style] === undefined) {
            stylesMap[product.shape] = true;
          }
          if (materialsMap[product.material] === undefined) {
            materialsMap[product.material] = true;
          }
          if (fitsMap[product.fit] === undefined) {
            fitsMap[product.fit] = true;
          }
          if (colorsMap[product.colorName] === undefined) {
            colorsMap[product.colorName] = true;
          }
        });
        // console.log('glassesMap', glassesMap);

        filterMap.brand = Object.keys(brandsMap);
        filterMap.style = Object.keys(stylesMap);
        filterMap.material = Object.keys(materialsMap);
        filterMap.fit = Object.keys(fitsMap);
        filterMap.colorName = Object.keys(colorsMap);
        // console.log('filterMap', filterMap);
      }

      function renderGlasses(data) {
        const glassesGridNode = document.getElementById('glasses-grid');

        glassesGridNode.innerHTML = glassesGrid({
          glasses: data,
        });
        if (!data.length) {
          glassesGridNode.innerHTML =
            'There are no products available for this combination.';
        }
      }

      function updateBanner(gender) {
        if (gender !== undefined) {
          if (gender === 'men') {
            $('.intro').removeClass('men women kids all');
            $('.intro').addClass('men');
          } else if (gender === 'women') {
            $('.intro').removeClass('men women kids all');
            $('.intro').addClass('women');
          } else if (gender === 'kids') {
            $('.intro').removeClass('men women kids all');
            $('.intro').addClass('kids');
          } else if (gender === 'all') {
            $('.intro').removeClass('men women kids all');
            $('.intro').addClass('all');
          }
        }
      }

      function applyFilters({
        gender,
        brand,
        style,
        color,
        material,
        face,
        fit,
        price,
      }) {
        let genderMatch = true;
        let brandMatch = true;
        let styleMatch = true;
        let colorMatch = true;
        let materialMatch = true;
        let faceMatch = true;
        let fitMatch = true;
        let priceMatch = true;

        filteredData = parsedGlassesData;

        console.log({
          gender,
          brand,
          style,
          color,
          material,
          face,
          fit,
          price,
        });

        filteredData = filteredData.filter((product) => {
          const pGender = product.gender;
          const pBrand = product.brand.toLowerCase();
          const pStyle = product.shape.toLowerCase();
          const pColor = product.colorName.toLowerCase();
          const pMaterial = product.material.toLowerCase();
          const pFace = product.faceShape;
          const pFit = product.fit.toLowerCase();
          const pPrice = product.price;

          // Gender
          if (gender.length > 0) {
            genderMatch = false;
            if (gender.length >= 2) {
              updateBanner('all');
            } else if (gender.includes('men')) {
              updateBanner('men');
            } else if (gender.includes('women')) {
              updateBanner('women');
            } else if (gender.includes('kids')) {
              updateBanner('kids');
            }

            for (let i = 0; i < gender.length; i++) {
              if (gender[i] === 'men' && pGender.men === true) {
                genderMatch = true;
              }

              if (gender[i] === 'women' && pGender.women === true) {
                genderMatch = true;
              }

              if (
                gender[i] === 'kids' &&
                (pFit === 'petit' || pFit === 'petite' || pFit === 'kids')
              ) {
                genderMatch = true;
              }

              if (gender[i] === 'all') {
                genderMatch = true;
              }
            }
          }

          // Brand
          if (brand.length > 0) {
            brandMatch = false;
            if (brand.indexOf(pBrand) > -1) {
              brandMatch = true;
            }
          }

          // Style
          if (style.length > 0) {
            styleMatch = false;
            if (style.indexOf(pStyle) > -1) {
              styleMatch = true;
            }
          }

          // Color
          if (color.length > 0) {
            colorMatch = false;
            if (color.indexOf(pColor) > -1) {
              colorMatch = true;
            }
          }

          if (material.length > 0) {
            materialMatch = false;
            if (material.indexOf(pMaterial) > -1) {
              materialMatch = true;
            }
          }

          if (face.length > 0) {
            faceMatch = false;
            for (let i = 0; i < face.length; i++) {
              if (face[i] && pFace && pFace[face[i]] === true) {
                faceMatch = true;
              }
            }
          }

          if (fit.length > 0) {
            fitMatch = false;
            if (fit.indexOf(pFit) > -1) {
              fitMatch = true;
            }
          }

          if (price.length > 0) {
            priceMatch = false;
            for (let i = 0; i < price.length; i++) {
              if (price[i] === 'Under $150'.toLowerCase() && pPrice < 150) {
                priceMatch = true;
              }
              if (
                price[i] === '$150-$250'.toLowerCase() &&
                pPrice >= 150 &&
                pPrice <= 250
              ) {
                priceMatch = true;
              }
              if (
                price[i] === '$250-$350'.toLowerCase() &&
                pPrice >= 250 &&
                pPrice <= 350
              ) {
                priceMatch = true;
              }
              if (
                price[i] === '$350-$450'.toLowerCase() &&
                pPrice >= 350 &&
                pPrice <= 450
              ) {
                priceMatch = true;
              }
              if (price[i] === '$450 & Up'.toLowerCase() && pPrice >= 450) {
                priceMatch = true;
              }
            }
          }

          // Return all matching filters
          return (
            genderMatch &&
            brandMatch &&
            styleMatch &&
            colorMatch &&
            materialMatch &&
            faceMatch &&
            fitMatch &&
            priceMatch
          );
        });

        // console.log('filteredData', filteredData);

        renderGlasses(filteredData);
      }

      function allEvents() {
        // clickEvents
        function filterEvents() {
          // click on filter categories show dropdown
          $(document).on('click ', '.filter-item', function (e) {
            if ($(this).hasClass('active')) {
              if (e.type === 'click') {
                $('.filter-item').removeClass('active');
                $(`.${$(this).data('filtertype')}-filter`).slideUp(500);
              }
            } else {
              $('.filter-slidedown').slideUp(0);
              $('.filter-item').removeClass('active');
              $(this).addClass('active');
              $(`.${$(this).data('filtertype')}-filter`).slideDown(500);
            }
          });

          // Mobile click on filter button
          $('.show-more-button').click(() => {
            $('.glasses-filter').fadeIn(250);
          });

          // Mobile close filter modal
          $(document).on('click', '.close-glasses-filter', () => {
            $('.mobile-only#filter-mobile .glasses-filter').fadeOut(250);
            $('html,body').animate(
              {
                scrollTop: $('.glasses-filter').offset().top,
              },
              0,
            );
          });

          // click on individual options within categories
          $(document).on('click', '.filter-slidedown .option', function () {
            if (!$(this).hasClass('active')) {
              $(this).addClass('active');
            } else {
              $(this).removeClass('active');
            }
          });

          // click on apply filters
          // Gather all active filters
          $(document).on('click', '.filter-button', () => {
            const selectedFilters = {
              gender: [],
              brand: [],
              style: [],
              color: [],
              face: [],
              fit: [],
              material: [],
              price: [],
            };

            if (isMobile()) {
              $('html,body').animate(
                {
                  scrollTop: $('.glasses-filter').offset().top,
                },
                0,
              );

              $('.mobile-only#filter-mobile .glasses-filter').fadeOut(250);
            }

            $('.filter-slidedown').slideUp(500);
            $('.filter-item').removeClass('active');
            $('.filter-container').empty();
            $('.filter-items .option').each(function () {
              if ($(this).hasClass('active')) {
                const thisType = $(this).data('filtertype');
                const thisOption = $(this).data('filteroption');
                let filterExists = false;

                // skip if label tag already created
                $('.active-filter').each(function () {
                  if ($(this).data('activeoption') === thisOption) {
                    filterExists = true;
                  }
                });

                // create and append filter label tag
                if (filterExists === false) {
                  // parse color
                  // if (thisType === 'color') {
                  //   thisOption = thisOption.split(' ').join('');
                  // }
                  selectedFilters[thisType].push(thisOption.toLowerCase());

                  $('.filter-container').append(
                    `<div class='active-filter' data-activetype='${thisType}' data-activeOption='${thisOption}'>${thisOption} <div class='close-x'>&times;</div></div>`,
                  );
                }
              }
            });

            applyFilters(selectedFilters);
          });

          // click to remove filter tag label
          $(document).on('click', '.active-filter', function () {
            $(this).remove();
            const thisType = $(this).data('activetype');
            const thisOption = $(this).data('activeoption');
            if (thisType === 'gender') {
              updateBanner('all');
              // reload top banner based on gender
              // GlassesManager.loadTopBanner("all");
            }
            $('.option.active').each(function () {
              if (
                $(this).data('filtertype') === thisType &&
                $(this).data('filteroption') === thisOption
              ) {
                $(this).removeClass('active');
              }
            });
            $('.filter-button').first().trigger('click');
          });

          const getGender = getUrlParameter('gender')
            ? getUrlParameter('gender').toLowerCase()
            : undefined;
          const getBrand = getUrlParameter('brand')
            ? getUrlParameter('brand').toUpperCase()
            : undefined;
          const getFace = getUrlParameter('face')
            ? getUrlParameter('face').toLowerCase()
            : undefined;

          if (getGender !== undefined) {
            // update filter checkbox and trigger apply filter
            $(
              `.filter-items .option[data-filtertype='gender'][data-filteroption='${getGender}']`,
            ).addClass('active');
          }

          if (getBrand !== undefined) {
            // update brand filter checkbox
            $(
              `.filter-items .option[data-filtertype='brand'][data-filteroption='${getBrand}']`,
            ).addClass('active');
          }

          if (getFace !== undefined) {
            // update faceshape filter checkbox
            $(
              `.filter-items .option[data-filtertype='face'][data-filteroption='${getFace}']`,
            ).addClass('active');
          }

          if (
            getGender !== undefined ||
            getBrand !== undefined ||
            getFace !== undefined
          ) {
            $('.filter-button').first().trigger('click');
          }
        }

        function sortEvents() {
          $(document).on('click', '.button.sort-price', function () {
            $(this).addClass('clicked');
            const sortedData =
              filteredData.length > 0 ? filteredData : parsedGlassesData;
            // $(".filter-slidedown").slideUp(500);
            if ($(this).data('filtercost') === 'lowtohigh') {
              $(this).data('filtercost', 'hightolow');
              $(this).children('.price-flip').html('Price low to high');
              $(this)
                .children('.price-arrow')
                .attr(
                  'src',
                  'https://storage.googleapis.com/imp-projects/lenscrafters/1.0.0/images/sort-by-up.png',
                );
              sortedData.sort(
                (a, b) => parseFloat(a.price) - parseFloat(b.price),
              );
            } else {
              $(this).data('filtercost', 'lowtohigh');
              $(this).children('.price-flip').html('Price high to low');
              $(this)
                .children('.price-arrow')
                .attr(
                  'src',
                  'https://storage.googleapis.com/imp-projects/lenscrafters/1.0.0/images/sort-by-down.png',
                );
              sortedData.sort(
                (a, b) => parseFloat(b.price) - parseFloat(a.price),
              );
            }
            // $(".filter-button").trigger("click");
            renderGlasses(sortedData);
          });

          // Sort by cost
          // if ($(".button.sort-price").hasClass("clicked")) {
          //   if ($(".button.sort-price").data("filtercost") === "lowtohigh") {
          //   } else {
          //   }

          // }
        }

        filterEvents();
        sortEvents();
      }

      function qvRotationalEvents(productId, colorId) {
        const rotationArray = [
          '060A',
          '090A',
          '120A',
          '150A',
          '180A',
          '210A',
          '240A',
          '270A',
          '300A',
          '330A',
          '000A',
          '030A',
        ];
        const this3DRotateArray = [];
        for (let i = 0; i < rotationArray.length; i++) {
          this3DRotateArray.push(
            `https://slimages.macysassets.com/is/image/McomMkt/0${productId}__${colorId}_${rotationArray[i]}?FMT=PNG-ALPHA&qlt=85,0&resMode=sharp2&scl=1`,
          );
        }

        // Glasses Controls
        let currentZoomIn = 0;
        let currentFromTop = 0;
        let currentZoomInWidth = 100;
        function resetZoom() {
          currentFromTop = 0;
          currentZoomInWidth = 100;
          currentZoomIn = 0;
          $('.larger-glasses-container .larger-glasses-img')
            .css('left', `${currentZoomIn}px`)
            .css('width', `${currentZoomInWidth}%`)
            .css('top', `${currentFromTop}px`);
        }

        function zoomImageIn() {
          currentZoomIn -= 20;
          currentZoomInWidth += 10;
          currentFromTop -= 20;
          $('.larger-glasses-container .larger-glasses-img')
            .css('left', `${currentZoomIn}px`)
            .css('width', `${currentZoomInWidth}%`)
            .css('top', `${currentFromTop}px`);
        }

        function zoomImageOut() {
          if (currentZoomInWidth > 70) {
            currentZoomIn += 20;
            currentZoomInWidth -= 10;
            currentFromTop += 20;
            $('.larger-glasses-container .larger-glasses-img')
              .css('left', `${currentZoomIn}px`)
              .css('width', `${currentZoomInWidth}%`)
              .css('top', `${currentFromTop}px`);
          }
        }

        function rotateThisImage(rotateTo) {
          $('.larger-glasses-img').attr('src', this3DRotateArray[rotateTo]);
        }

        function preloadImages(array) {
          if (!preloadImages.list) {
            preloadImages.list = [];
          }
          const list = preloadImages.list;
          for (let i = 0; i < array.length; i++) {
            const img = new Image();
            img.onload = function () {
              const index = list.indexOf(this);
              if (index !== -1) {
                list.splice(index, 1);
              }
            };
            list.push(img);
            img.src = array[i];
          }
        }

        function autoRotate() {
          let counter = 0;
          const i = setInterval(() => {
            // do your thing
            counter++;
            rotateThisImage(counter);
            if (counter === 11) {
              clearInterval(i);
            }
          }, 200);
        }

        $('.qv-wrapper').on('click', '.zoom-in', () => {
          zoomImageIn();
        });
        $('.qv-wrapper').on('click', '.zoom-out', () => {
          zoomImageOut();
        });
        $('.larger-glasses-container').scroll((e) => {
          e.preventDefault();
        });

        preloadImages(this3DRotateArray);
        setTimeout(autoRotate, 1000);

        $('.loader-ellipsis').fadeOut(0);
        $('.expandedView .c').fadeIn(250);

        $('.qv-wrapper').on('dragstart', 'img', (event) => {
          event.preventDefault();
        });

        $('.qv-wrapper').on(
          'mousewheel DOMMouseScroll',
          '.picDisplay',
          function (e) {
            const e0 = e.originalEvent;
            const delta = e0.wheelDelta || -e0.detail;

            this.scrollTop += (delta < 0 ? 1 : -1) * 30;
            e.preventDefault();

            if (delta >= 0) {
              zoomImageIn();
            } else {
              zoomImageOut();
            }
          },
        );

        let currentRotation = 0;
        let thisX;
        $('.qv-wrapper').on(
          'mousedown touchstart',
          '.larger-glasses-img',
          function (e) {
            thisX =
              e.originalEvent &&
              e.originalEvent.touches &&
              e.originalEvent.touches[0] &&
              e.originalEvent.touches[0].pageX
                ? e.originalEvent.touches[0].pageX
                : e.pageX;
            $(this).data('mousedown', true);
          },
        );
        $('.qv-wrapper').on(
          'mouseup touchend',
          '.larger-glasses-img',
          function () {
            $(this).data('mousedown', false);
          },
        );

        $('.qv-wrapper').on('mouseleave', '.larger-glasses-img', function () {
          $(this).data('mousedown', false);
        });

        // Rotate the image
        $('.qv-wrapper').on(
          'mousemove touchmove',
          '.larger-glasses-img',
          function (e) {
            const currentX =
              e.originalEvent &&
              e.originalEvent.touches &&
              e.originalEvent.touches[0] &&
              e.originalEvent.touches[0].pageX
                ? e.originalEvent.touches[0].pageX
                : e.pageX;

            if ($(this).data('mousedown') || $(this).data('touchstart')) {
              if (currentX < thisX) {
                if (currentX + 40 < thisX) {
                  resetZoom();
                  // console.log('X: ' + e.pageX + ', startX: ' + thisX + " Current Rotation: " + currentRotation);
                  thisX -= 40;
                  if (currentRotation === 11) {
                    currentRotation = 0;
                  } else {
                    currentRotation++;
                  }
                  rotateThisImage(currentRotation);
                }
              } else if (currentX - 40 > thisX) {
                resetZoom();
                // console.log('X: ' + e.pageX + ', startX: ' + thisX + " Current Rotation: " + currentRotation);
                thisX += 40;
                if (currentRotation === 0) {
                  currentRotation = 11;
                } else {
                  currentRotation--;
                }
                rotateThisImage(currentRotation);
              }
            }
          },
        );

        // Spin Glasses left
        $('.qv-wrapper').on('click', '.arrow-left', () => {
          if (currentRotation === 11) {
            currentRotation = 0;
          } else {
            currentRotation++;
          }
          resetZoom();
          rotateThisImage(currentRotation);
        });

        // Spin glasses right
        $('.qv-wrapper').on('click', '.arrow-right', () => {
          if (currentRotation === 0) {
            currentRotation = 11;
          } else {
            currentRotation--;
          }
          resetZoom();
          rotateThisImage(currentRotation);
        });

        // On click of close button
        $('.qv-wrapper').on('click scroll', '.close-glasses-details', () => {
          // When the modal is hidden...
          const scrollY = document.body.style.top;
          document.body.style.position = '';
          document.body.style.top = '';
          window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
          if (isMobile()) {
            $('.thisguy .expandedView').animate(
              {
                left: `${-100}vw`,
              },
              500,
            );
          } else {
            $('.glasses-details-row').slideUp(500);
            setTimeout(() => {
              $('.glasses-details-row').empty();
            }, 500);
          }
          $('.qv-wrapper').off();
        });
      }

      function openQV() {
        $(document).on('click', '.glasses-product', function () {
          $('.glasses-details-row').slideUp(500);
          const productId = $(this).data('productid');
          const colorId = $(this).data('colorid');

          if (isMobile()) {
            // When the modal is shown, we want a fixed body
            document.body.style.top = `-${window.scrollY}px`;
            document.body.style.position = 'fixed';
            $('.qv-wrapper.mobile-only')
              .html(
                glassesMobileQV({
                  ...glassesMap[productId][colorId],
                }),
              )
              .show();
            $('.thisguy .expandedView').height($(window).height());
            $('.thisguy .expandedView').animate(
              {
                left: `${0}px`,
              },
              500,
            );
          } else {
            $(this)
              .closest('.container')
              .next('.qv-wrapper')
              .html(
                glassesQV({
                  ...glassesMap[productId][colorId],
                }),
              )
              .slideDown(500);
          }

          qvRotationalEvents(productId, colorId);
        });

        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        // Create and Send Frames Email
        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

        function validateEmail(email) {
          /* eslint-disable-next-line */
          const re =
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(email);
        }

        function sendFramesEmail() {
          const email = $('.sendFramesInput').val();

          const cur = $('.sendFramesEmail');
          if (validateEmail(email)) {
            const thisUPC = cur.data('thisupc');
            const productId = cur.data('productid');
            const colorId = cur.data('colorid');

            const { brand, description, price } =
              glassesMap[productId][colorId];

            /* eslint-disable-next-line */
            const imageStr = `https://slimages.macysassets.com/is/image/McomMkt/0${productId}__${colorId}_030A?FMT=PNG-ALPHA&qlt=85,0&resMode=sharp2&scl=1`;
            const body = {
              data: {
                template: 'lenscrafters',
                from: "LensCrafters at Macy's <noreply.social@macys.com>",
                email,
                data: {
                  image: imageStr,
                  brand,
                  productid: productId,
                  price: `$${price}`,
                  upc: thisUPC,
                  description,
                  link: 'https://www.macys.com/p/lenscrafters/glasses/',
                  subject: 'Here are those frames you liked from LensCrafters!',
                },
              },
            };
            const emailAPI = `${bootStrapData.IMP_API_URL}/api/v2/email-templates/send`;
            axios({
              url: emailAPI,
              method: 'post',
              crossOrigin: true,
              data: body,
            })
              .then((res) => {
                cur.html('SENT');
                cur.addClass('email-sent');
                return console.log(res);
              })
              .catch((e) => console.error(e));

            console.log('Send Email: ', body);
          } else {
            alert('Please enter a correctly formatted email.');
          }
        }

        $(document).on('keyup', '.sendFramesInput', (e) => {
          if (e.keyCode === 13) {
            e.preventDefault();
            sendFramesEmail();
          }
        });

        $(document).on('click', '.sendFramesEmail', sendFramesEmail);

        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        // Copy Link
        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

        function copyToClipboardFF(text) {
          window.prompt('Copy to clipboard: Ctrl C, Enter', text);
        }

        function copyToClipboard() {
          let success = true;
          const range = document.createRange();
          let selection;

          // For IE.
          if (window.clipboardData) {
            window.clipboardData.setData('Text', $('.copyTextInput').val());
          } else {
            // Create a temporary element off screen.
            const tmpElem = $('<div>');
            tmpElem.css({
              position: 'absolute',
              left: '-1000px',
              top: '-1000px',
            });
            // Add the input value to the temp element.
            tmpElem.text($('.copyTextInput').val());
            $('body').append(tmpElem);
            // Select temp element.
            range.selectNodeContents(tmpElem.get(0));
            selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            // Lets copy.
            try {
              success = document.execCommand('copy', false, null);
            } catch (e) {
              copyToClipboardFF($('.copyTextInput').val());
            }
            if (success) {
              // remove temp element.
              tmpElem.remove();
            }
          }
        }
        $(document).on('click', '.copy-link', function () {
          copyToClipboard();
          $(this).addClass('copied');
          $(this).html('COPIED');
          $('.copyTextInput').addClass('copied');
        });
      }

      fetchGlasses();
      renderGlasses(parsedGlassesData);
      allEvents();

      openQV();
    }

    function printWishListInit() {
      function qvRotationalEvents(productId, colorId) {
        const rotationArray = [
          '060A',
          '090A',
          '120A',
          '150A',
          '180A',
          '210A',
          '240A',
          '270A',
          '300A',
          '330A',
          '000A',
          '030A',
        ];
        const this3DRotateArray = [];
        for (let i = 0; i < rotationArray.length; i++) {
          this3DRotateArray.push(
            `https://slimages.macysassets.com/is/image/McomMkt/0${productId}__${colorId}_${rotationArray[i]}?FMT=PNG-ALPHA&qlt=85,0&resMode=sharp2&scl=1`,
          );
        }

        // Glasses Controls
        let currentZoomIn = 0;
        let currentFromTop = 0;
        let currentZoomInWidth = 100;
        function resetZoom() {
          currentFromTop = 0;
          currentZoomInWidth = 100;
          currentZoomIn = 0;
          $('.larger-glasses-container .larger-glasses-img')
            .css('left', `${currentZoomIn}px`)
            .css('width', `${currentZoomInWidth}%`)
            .css('top', `${currentFromTop}px`);
        }

        function zoomImageIn() {
          currentZoomIn -= 20;
          currentZoomInWidth += 10;
          currentFromTop -= 20;
          $('.larger-glasses-container .larger-glasses-img')
            .css('left', `${currentZoomIn}px`)
            .css('width', `${currentZoomInWidth}%`)
            .css('top', `${currentFromTop}px`);
        }

        function zoomImageOut() {
          if (currentZoomInWidth > 70) {
            currentZoomIn += 20;
            currentZoomInWidth -= 10;
            currentFromTop += 20;
            $('.larger-glasses-container .larger-glasses-img')
              .css('left', `${currentZoomIn}px`)
              .css('width', `${currentZoomInWidth}%`)
              .css('top', `${currentFromTop}px`);
          }
        }

        function rotateThisImage(rotateTo) {
          $('.larger-glasses-img').attr('src', this3DRotateArray[rotateTo]);
        }

        function preloadImages(array) {
          if (!preloadImages.list) {
            preloadImages.list = [];
          }
          const list = preloadImages.list;
          for (let i = 0; i < array.length; i++) {
            const img = new Image();
            img.onload = function () {
              const index = list.indexOf(this);
              if (index !== -1) {
                list.splice(index, 1);
              }
            };
            list.push(img);
            img.src = array[i];
          }
        }

        function autoRotate() {
          let counter = 0;
          const i = setInterval(() => {
            // do your thing
            counter++;
            rotateThisImage(counter);
            if (counter === 11) {
              clearInterval(i);
            }
          }, 200);
        }

        $('.qv-wrapper').on('click', '.zoom-in', () => {
          zoomImageIn();
        });
        $('.qv-wrapper').on('click', '.zoom-out', () => {
          zoomImageOut();
        });
        $('.larger-glasses-container').scroll((e) => {
          e.preventDefault();
        });

        preloadImages(this3DRotateArray);
        setTimeout(autoRotate, 1000);

        $('.loader-ellipsis').fadeOut(0);
        $('.expandedView .c').fadeIn(250);

        $('.qv-wrapper').on('dragstart', 'img', (event) => {
          event.preventDefault();
        });

        $('.qv-wrapper').on(
          'mousewheel DOMMouseScroll',
          '.picDisplay',
          function (e) {
            const e0 = e.originalEvent;
            const delta = e0.wheelDelta || -e0.detail;

            this.scrollTop += (delta < 0 ? 1 : -1) * 30;
            e.preventDefault();

            if (delta >= 0) {
              zoomImageIn();
            } else {
              zoomImageOut();
            }
          },
        );

        let currentRotation = 0;
        let thisX;
        $('.qv-wrapper').on(
          'mousedown touchstart',
          '.larger-glasses-img',
          function (e) {
            thisX =
              e.originalEvent &&
              e.originalEvent.touches &&
              e.originalEvent.touches[0] &&
              e.originalEvent.touches[0].pageX
                ? e.originalEvent.touches[0].pageX
                : e.pageX;
            $(this).data('mousedown', true);
          },
        );
        $('.qv-wrapper').on(
          'mouseup touchend',
          '.larger-glasses-img',
          function () {
            $(this).data('mousedown', false);
          },
        );

        $('.qv-wrapper').on('mouseleave', '.larger-glasses-img', function () {
          $(this).data('mousedown', false);
        });

        // Rotate the image
        $('.qv-wrapper').on(
          'mousemove touchmove',
          '.larger-glasses-img',
          function (e) {
            const currentX =
              e.originalEvent &&
              e.originalEvent.touches &&
              e.originalEvent.touches[0] &&
              e.originalEvent.touches[0].pageX
                ? e.originalEvent.touches[0].pageX
                : e.pageX;

            if ($(this).data('mousedown') || $(this).data('touchstart')) {
              if (currentX < thisX) {
                if (currentX + 40 < thisX) {
                  resetZoom();
                  // console.log('X: ' + e.pageX + ', startX: ' + thisX + " Current Rotation: " + currentRotation);
                  thisX -= 40;
                  if (currentRotation === 11) {
                    currentRotation = 0;
                  } else {
                    currentRotation++;
                  }
                  rotateThisImage(currentRotation);
                }
              } else if (currentX - 40 > thisX) {
                resetZoom();
                // console.log('X: ' + e.pageX + ', startX: ' + thisX + " Current Rotation: " + currentRotation);
                thisX += 40;
                if (currentRotation === 0) {
                  currentRotation = 11;
                } else {
                  currentRotation--;
                }
                rotateThisImage(currentRotation);
              }
            }
          },
        );

        // Spin Glasses left
        $('.qv-wrapper').on('click', '.arrow-left', () => {
          if (currentRotation === 11) {
            currentRotation = 0;
          } else {
            currentRotation++;
          }
          resetZoom();
          rotateThisImage(currentRotation);
        });

        // Spin glasses right
        $('.qv-wrapper').on('click', '.arrow-right', () => {
          if (currentRotation === 0) {
            currentRotation = 11;
          } else {
            currentRotation--;
          }
          resetZoom();
          rotateThisImage(currentRotation);
        });

        // On click of close button
        $('.qv-wrapper').on('click scroll', '.close-glasses-details', () => {
          // When the modal is hidden...
          const scrollY = document.body.style.top;
          document.body.style.position = '';
          document.body.style.top = '';
          window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
          if (isMobile()) {
            $('.thisguy .expandedView').animate(
              {
                left: `${-100}vw`,
              },
              500,
            );
          } else {
            $('.glasses-details-row').slideUp(500);
            setTimeout(() => {
              $('.glasses-details-row').empty();
            }, 500);
          }
          $('.qv-wrapper').off();
        });
      }

      const glassesUPC = getUrlParameter('frameUPCs');

      const productInfo = glassesData.filter(
        (glasses) => glasses.UPC === glassesUPC,
      )[0];

      const wishListDetailsNode = document.getElementById('product-details');

      wishListDetailsNode.innerHTML = wishListDetails({
        ...productInfo,
      });

      $(document).on('click', '#wish-list-image', function () {
        if (!isMobile()) {
          $(this)
            .closest('.container')
            .next('.qv-wrapper')
            .html(
              glassesQV({
                ...productInfo,
              }),
            )
            .slideDown(500);

          $('p.instructions').hide();
          $('.sendFramesInput').hide();
          $('.sendFramesEmail').hide();
          $('.copy-link.button').hide();

          qvRotationalEvents(productInfo.productId, productInfo.colorId);
        }
      });
    }

    // --------------------------------- ROUTING --------------------------------------

    /* eslint-disable-next-line no-unused-vars,no-global-assign,no-undef,camelcase */
    const urlPath = window.location.pathname.split('/').filter((p) => p);
    // console.log(urlPath);

    /* eslint-disable-next-line no-unused-vars,no-global-assign,no-undef,camelcase */
    const pagePath = urlPath[urlPath.length - 1];
    // console.log('pagepath', pagePath);

    if (pagePath === 'visit-us') {
      // console.log('visit us page');
      // visitUsInit();
    } else if (pagePath === 'glasses') {
      console.log('glasses page');
      glassesInit();
    } else if (pagePath === 'print-wish-list') {
      console.log('print-wish-list page');
      printWishListInit();
    } else if (pagePath === 'offers') {
      console.log('offers page');
    } else if (pagePath === 'services') {
      console.log('services page');
    } else if (pagePath === 'home-alt') {
      console.log('services page');
    } else if (pagePath === 'face-shape') {
      console.log('face shape page');
      $(document).ready(() => {
        $('.carousel').slick({
          slidesToShow: 1,
          dots: true,
          arrows: true,
          customPaging(slider, i) {
            const title = $(slider.$slides[i])
              .find('[data-title]')
              .data('title');
            return `<a class="pager__item"> ${title} </a>`;
          },
          centerMode: true,
        });
        $('.inner-carousel').slick({
          slidesToShow: 1,
          dots: true,
          arrows: false,
          centerMode: true,
        });
        $('.shape-links-container a').click(function (e) {
          e.preventDefault();
          $('body, html').animate(
            {
              scrollTop: $($(this).attr('href')).offset().top,
            },
            'slow',
          );
          $('.shape-links-container a').removeClass('active');
          $(this).addClass('active');
          const stickyNavTop = $('.shape-links-container').offset().top;

          // our function that decides weather the navigation bar should have "fixed" css position or not.
          const stickyNav = function () {
            const scrollTop = $(window).scrollTop(); // our current vertical position from the top

            // if we've scrolled more than the navigation, change its position to fixed to stick to top,
            // otherwise change it back to relative
            if (scrollTop > stickyNavTop) {
              $('.shape-links-container').addClass('sticky');
            } else {
              $('.shape-links-container').removeClass('sticky');
            }
          };

          stickyNav();
          // and run it again every time you scroll
          $(window).scroll(() => {
            stickyNav();
          });
        });
      });
    } else if (pagePath === 'contact-lenses') {
      console.log('contact lenses page');
    } else if (pagePath === 'eyecare-services') {
      console.log('eyecare services page');
      $(document).ready(() => {
        $('#adult-exam').addClass('video-select-active');
      });
      $(document).on('click', '#kids-exam', () => {
        $('#kids-exam-holder').show();
        $('#adult-exam-holder').hide();
        $('#adult-exam-holder video').trigger('pause');
        $('#kids-exam').addClass('video-select-active');
        $('#adult-exam').removeClass('video-select-active');
      });
      $(document).on('click', '#adult-exam', () => {
        $('#adult-exam-holder').show();
        $('#kids-exam-holder').hide();
        $('#kids-exam-holder video').trigger('pause');
        $('#adult-exam').addClass('video-select-active');
        $('#kids-exam').removeClass('video-select-active');
      });
    } else if (pagePath === 'insurance') {
      console.log('insurance page');

      // FAQ TOGGLE
      // html: accordion.hbs
      $('.accordion-item').on('click', function () {
        if ($(this).children('.accordion-item-contents').hasClass('active')) {
          $(this).children('.accordion-item-contents').removeClass('active');
          $('.accordion-icon').text('+');
        } else {
          $('.accordion-item-contents').removeClass('active');
          $('.accordion-icon').text('+');
          $(this).children('.accordion-item-contents').addClass('active');
          $(this)
            .children('.accordion-item-title-container')
            .children('.accordion-icon')
            .text('–');
        }
      });
    } else if (pagePath === 'shop-frames') {
      console.log('shop-frames page');
    } else {
      // home page

      // **************** MIGHT NEED TO UNCOMMENT THIS!!!!!! #################
      homeInit();
    }
  },
};



// WEBPACK FOOTER //
// /home/jenkins/agent/workspace/marketing-campaigns_deploy_trigger_ce_v2/package/app.js